export const PV_STATIONS = [
  {
    name: "三佳站",
    lat: 35.091,
    lng: 112.602,
    status: "online",
    devs: 32,
    url: "/station/sanjia",
  },
  {
    name: "河西站",
    lat: 35.073,
    lng: 112.618,
    status: "online",
    devs: 28,
    url: "/station/hexi",
  },
  {
    name: "虎岭站",
    lat: 35.084,
    lng: 112.575,
    status: "warn",
    devs: 24,
    url: "/station/huling",
  },
  {
    name: "孔山站",
    lat: 35.102,
    lng: 112.585,
    status: "online",
    devs: 20,
    url: "/station/kongshan",
  },
  {
    name: "济水大道基站",
    lat: 35.076,
    lng: 112.596,
    status: "online",
    devs: 18,
    url: "/station/jishui",
  },
  {
    name: "克井镇基站",
    lat: 35.128,
    lng: 112.592,
    status: "offline",
    devs: 14,
    url: "/station/kejing",
  },
  {
    name: "高新区基站",
    lat: 35.048,
    lng: 112.568,
    status: "online",
    devs: 16,
    url: "/station/gaoxin",
  },
  {
    name: "坡头镇基站",
    lat: 35.112,
    lng: 112.632,
    status: "warn",
    devs: 12,
    url: "/station/potou",
  },
];

export const STATUS_COLORS = {
  online: "#00e676",
  warn: "#ffd600",
  offline: "#ff5252",
};

export const STATUS_NAMES = {
  online: "正常",
  warn: "告警",
  offline: "离线",
};

export const INITIAL_ALARMS = [
  {
    station: "虎岭站",
    msg: "空调故障",
    time: "2min前",
    level: "red",
  },
  {
    station: "孔山站",
    msg: "光伏逆变异常",
    time: "15min前",
    level: "orange",
  },
  {
    station: "济水大道",
    msg: "电池SOC偏低",
    time: "32min前",
    level: "orange",
  },
  {
    station: "河西站",
    msg: "温度过高预警",
    time: "1h前",
    level: "yellow",
  },
  {
    station: "坡头镇",
    msg: "通讯延迟",
    time: "2h前",
    level: "yellow",
  },
];

export const ENV_JUMP_DETAIL = {
  三佳站: {
    temp: 24.8,
    humid: 48,
    status: "正常",
    faults: 0,
    acStatus: "制冷中26°C",
    door: "关",
    smoke: "正常",
    power: "2.3kW",
  },
  河西站: {
    temp: 26.2,
    humid: 56,
    status: "预警",
    faults: 1,
    acStatus: "制冷中28°C",
    door: "关",
    smoke: "正常",
    power: "2.8kW",
  },
  虎岭站: {
    temp: 32.5,
    humid: 38,
    status: "告警",
    faults: 2,
    acStatus: "故障⚠️",
    door: "开⚠️",
    smoke: "正常",
    power: "1.1kW",
  },
  孔山站: {
    temp: 23.1,
    humid: 51,
    status: "正常",
    faults: 1,
    acStatus: "制冷中24°C",
    door: "关",
    smoke: "正常",
    power: "1.8kW",
  },
  济水大道: {
    temp: 25.6,
    humid: 56,
    status: "正常",
    faults: 1,
    acStatus: "制冷中26°C",
    door: "关",
    smoke: "正常",
    power: "2.1kW",
  },
  克井镇: {
    temp: 27.3,
    humid: 61,
    status: "预警",
    faults: 0,
    acStatus: "制冷中28°C",
    door: "关",
    smoke: "正常",
    power: "1.5kW",
  },
  坡头镇: {
    temp: 29.1,
    humid: 42,
    status: "预警",
    faults: 1,
    acStatus: "制冷中30°C",
    door: "关",
    smoke: "正常",
    power: "1.2kW",
  },
  高新区站: {
    temp: 22.8,
    humid: 45,
    status: "正常",
    faults: 0,
    acStatus: "制冷中23°C",
    door: "关",
    smoke: "正常",
    power: "1.6kW",
  },
};

/** 滚动列表单列数据（会与自身拼接实现无缝滚动） */
export const DEVICE_SCROLL_ROWS = [
  {
    key: "k1",
    name: "克井镇",
    dotClass: "offline",
    suffix: '27.3°C <span style="color:#ff5252">🔴离线</span>',
  },
  {
    key: "k2",
    name: "虎岭站",
    dotClass: "warn",
    suffix: '32.5°C <span style="color:#ff5252">⚠️故障</span>',
  },
  {
    key: "k3",
    name: "坡头镇",
    dotClass: "warn",
    suffix: '29.1°C <span style="color:#ffa500">⚠️</span>',
  },
  {
    key: "k4",
    name: "三佳站",
    dotClass: "online",
    suffix:
      '<span style="color:rgba(255,255,255,0.4)">24.8°C</span>',
  },
  {
    key: "k5",
    name: "河西站",
    dotClass: "online",
    suffix:
      '<span style="color:rgba(255,255,255,0.4)">26.2°C</span>',
  },
  {
    key: "k6",
    name: "孔山站",
    dotClass: "online",
    suffix:
      '<span style="color:rgba(255,255,255,0.4)">23.1°C</span>',
  },
  {
    key: "k7",
    name: "济水大道",
    dotClass: "online",
    suffix:
      '<span style="color:rgba(255,255,255,0.4)">25.6°C</span>',
  },
  {
    key: "k8",
    name: "高新区站",
    dotClass: "online",
    suffix:
      '<span style="color:rgba(255,255,255,0.4)">22.8°C</span>',
  },
];

export function alertExportHint(text) {
  window.alert(text);
}

export function showStationJumpAlert(name) {
  const fallback = {
    temp: "--",
    humid: "--",
    status: "未知",
    faults: 0,
    acStatus: "--",
    door: "--",
    smoke: "--",
    power: "--",
  };
  const d = ENV_JUMP_DETAIL[name] || fallback;
  const icon =
    d.status === "告警" ? "🔴" : d.status === "预警" ? "🟡" : "🟢";
  const info =
    `━━━ 设备状态详情 ━━━\n` +
    `📍 站点：${name}\n` +
    `${icon} 状态：${d.status}\n` +
    `🔧 故障数量：${d.faults} 个\n\n` +
    `🌡️ 温度：${d.temp}°C\n` +
    `💧 湿度：${d.humid}%\n` +
    `❄️ 空调：${d.acStatus}\n` +
    `🚪 门禁：${d.door}\n` +
    `💨 烟感：${d.smoke}\n` +
    `⚡ 功率：${d.power}\n\n` +
    `🔗 实际开发中跳转至：\n/station/${encodeURIComponent(
      name
    )}/environment`;
  window.alert(info);
}
